import React, { ReactNode, useContext, useState } from 'react';

import { useCoinContext } from './CoinContext';
import { getPackByPriceId } from '../lib/coinPacks';
import StripeModal from '../components/modals/StripeModal';
import CoinMenuModal from '../components/modals/CoinMenuModal';

interface IUCoinModalContext {
  showMenuModal: ({ needed }: {
    needed?: number
  }) => void;
}

const CoinModalContext = React.createContext<IUCoinModalContext | null>(null);

export function CoinModalContextProvider(props: {
  children: React.ReactNode
}) {
  const coinContext = useCoinContext();

  const [needed, setNeeded] = useState<number | undefined>();
  const [menuShown, setMenuShown] = useState(false);

  const coinPack = getPackByPriceId(coinContext.priceId);

  const showMenuModal = ({ needed }: {
    needed?: number
  }) => {
    setNeeded(needed);
    setMenuShown(true);
  };

  const close = () => {
    setMenuShown(false);
    coinContext.cancelPurchase();
  };

  let modal: ReactNode = null;
  if (coinPack && coinContext.clientSecret) {
    modal = <StripeModal close={close} coinPack={coinPack} clientSecret={coinContext.clientSecret}/>;
  } else if (menuShown) {
    modal = <CoinMenuModal close={close} needed={needed}/>;
  }

  const context: IUCoinModalContext = {
    showMenuModal
  };

  return <CoinModalContext.Provider value={context}>
    {modal}
    {props.children}
  </CoinModalContext.Provider>;
}

export const useCoinModalContext = () => {
  const context = useContext(CoinModalContext);
  if (context === null) {
    throw new Error('useCoinModalContext must be used within a CoinModalContextProvider');
  }
  return context;
};

